/**
 * Generates a CSV file and triggers a browser download.
 *
 * @param {string} filename - Name of the downloaded file (without extension).
 * @param {Array<{ label: string, value: (row) => string|number }>} columns
 * @param {Array<object>} rows
 *
 * Alternatively, pass an array of sections for multi-table exports:
 * @param {string} filename
 * @param {Array<{ title: string, columns: Array, rows: Array }>} sections
 */
export default function downloadCsv(filename, columnsOrSections, rows) {
  const escape = (val) => {
    const raw = val == null ? "" : String(val);
    const safe = /^[\t\r ]*[=+\-@]/.test(raw) ? `'${raw}` : raw;
    return safe.includes(",") ||
      safe.includes('"') ||
      safe.includes("\n") ||
      safe.includes("\r")
      ? `"${safe.replace(/"/g, '""')}"`
      : safe;
  };

  const buildTable = (columns, data) => {
    const header = columns.map((c) => escape(c.label)).join(",");
    const body = data
      .map((row) => columns.map((c) => escape(c.value(row))).join(","))
      .join("\n");
    return header + "\n" + body;
  };

  let csv;
  if (rows) {
    // Simple single-table call: downloadCsv(filename, columns, rows)
    csv = buildTable(columnsOrSections, rows);
  } else {
    // Multi-section call: downloadCsv(filename, sections)
    csv = columnsOrSections
      .filter((s) => s.rows.length > 0)
      .map((s) => s.title + "\n" + buildTable(s.columns, s.rows))
      .join("\n\n");
  }

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}_${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
